import React from 'react';
import PropTypes from 'prop-types';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ConditionalWrap } from 'common/Utils';
import Section from '../Section';
import { assignmentInitialValuesPropType } from '../PropTypes';
import sectionStyles from '../Section.module.scss';
import UnitLessonSelector from './UnitLessonSelector';
import AssignableTypeDropdown from './AssignableTypeDropdown';
import AssignableModelsSelector from './AssignableModelsSelector';
import MaxScoreField from './MaxScoreField';
import { PopulateStore } from './AssignableModels/utils';

const WhatSection = ({
  form,
  formChangeValue,
  initialIsUnit,
  initialLessonId,
  initialValues,
  openAssessmentInNewTab,
  programID,
  showWhatTitle,
  stafferId,
}) => (
  <ConditionalWrap
    condition={showWhatTitle}
    wrap={children => (
      <Section title="What">{children}</Section>
    )}
  >
    <QueryClientProvider client={new QueryClient()}>
      <div className={sectionStyles.row}>
        <div className={`mb10 ${sectionStyles.fieldContainer}`}>

          <PopulateStore
            form={form}
            formChangeValue={formChangeValue}
            initialValues={{
              canEditMaxScore: initialValues.can_edit_max_score !== false,
              gradingNotebookBy: initialValues.grading_notebook_by,
              maxScore: initialValues.max_score,
              modelType: initialValues.modelType,
              modelsToAssign: initialValues.modelsToAssign,
              openAssessmentInNewTab: openAssessmentInNewTab,
              randomizeAnswers: initialValues.randomize_answers,
              readingAssignableSelections: initialValues.readingAssignableSelections,
              showAnswersToStudents: initialValues.show_answers_to_students,
              slideShowSelect: initialValues.slideShowSelect,
            }}
            programId={programID}
            stafferId={stafferId}
          />

          <UnitLessonSelector
            formChangeValue={formChangeValue}
            initialIsUnit={initialIsUnit}
            initialUnitLessonId={initialLessonId}
            labelStyle={sectionStyles.label}
            programId={programID}
          />
        </div>
      </div>

      <div className={sectionStyles.row}>
        <AssignableTypeDropdown programId={programID} />
      </div>
      <div className={sectionStyles.row}>
        <AssignableModelsSelector
          form={form}
          formChangeValue={formChangeValue}
        />
      </div>

      <MaxScoreField
        form={form}
        formChangeValue={formChangeValue}
      />

    </QueryClientProvider>
  </ConditionalWrap>
);

WhatSection.propTypes = {
  form: PropTypes.shape({
    getState: PropTypes.func.isRequired
  }).isRequired,
  formChangeValue: PropTypes.func.isRequired,
  initialIsUnit: PropTypes.bool,
  initialLessonId: PropTypes.number,
  initialValues: assignmentInitialValuesPropType,
  openAssessmentInNewTab: PropTypes.bool,
  programID: PropTypes.number.isRequired,
  showWhatTitle: PropTypes.bool,
  stafferId: PropTypes.number
};

WhatSection.defaultProps = {
  initialIsUnit: false,
  initialLessonId: null,
  initialValues: {},
  openAssessmentInNewTab: false,
  showWhatTitle: true,
};

export default WhatSection;
